
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class EcobonusCheckDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false

  valid = false

  loading = false

  ecPrecheck1 = null

  ecPrecheck2 = null

  ecPrecheck3 = null

  ecPrecheck4 = null

  ecPrecheck5 = null

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.ecPrecheck1 = null;
    }
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  @Watch('ecPrecheck1')
  onEcPrecheck1Change() {
    this.ecPrecheck2 = null;
  }

  @Watch('ecPrecheck2')
  onEcPrecheck2Change() {
    this.ecPrecheck3 = null;
  }

  @Watch('ecPrecheck3')
  onEcPrecheck3Change() {
    this.ecPrecheck4 = null;
  }

  @Watch('ecPrecheck4')
  onEcPrecheck4Change() {
    this.ecPrecheck5 = null;
  }

  get user() {
    return this.$store.getters.currentUser;
  }

  get lead() {
    return this.$store.getters.currentLead;
  }

  get ecobonusPrecheckDone() {
    if (this.ecPrecheck1 === true
      || this.ecPrecheck2 === false
      || this.ecPrecheck3 === false
      || this.ecPrecheck4 === false
      || this.ecPrecheck5 === true) return true;

    return this.ecPrecheck1 !== null
      && this.ecPrecheck2 !== null
      && this.ecPrecheck3 !== null
      && this.ecPrecheck4 !== null
      && this.ecPrecheck5 !== null;
  }

  get ecobonusPrecheckSuccess() {
    return this.ecPrecheck1 === false
      && this.ecPrecheck2 === true
      && this.ecPrecheck3 === true
      && this.ecPrecheck4 === true
      && this.ecPrecheck5 === false;
  }

  onCancel() {
    this.dialog = false;
  }

  onStart() {
    // Indirizzo dal backend: quello cablato portava dentro l'account del
    // cliente precedente. Integrazione spenta, quindi qui non si arriva.
    const base = this.$store.getters.getIntegrations.ecobonusCheck.url;
    if (!base) return;

    const url = `${base}/${this.lead.id}/${this.user.name}`;

    window.location.href = encodeURI(url);
  }
}
